<template>
  <div class="kq-table-pagination" :style="{ marginBottom: isBottom ? '-20px' : '0' }">
    <el-pagination
      :current-page="page"
      :page-size="rows"
      :total="total"
      :page-sizes="pageSizes"
      :layout="tableLayout"
      @current-change="currentChange"
      @size-change="sizeChange"
      :small="small"
      background
    />
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    page: {
      required: true
    },
    rows: {
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 20, 30, 50]
    },
    tableLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    small: {
      type: Boolean,
      default: false
    },
    isBottom: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    currentChange(val) {
      this.$emit('update:page', val)
      this.$emit('request')
    },
    sizeChange(val) {
      this.$emit('update:page', 1)
      this.$emit('update:rows', val)
      this.$emit('request')
    }
  }
}
</script>

<style scoped>
.kq-table-pagination {
  padding: 20px 0;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}
</style>
